/**
 * Checks if the given errors object contains a specific error for a specific field.
 * @param errors - The errors object returned from the API. e.g., { name: ["validation.unique", "validation.format"] }
 * @param field - The field to check for errors. e.g., "name"
 * @param errorKey - The specific error key to check for. e.g., "validation.unique"
 * @returns True if the error exists, false otherwise.
 */
export const isAPIError = (
  data: {
    errors?: { [key: string]: string[] };
    message?: string;
  },
  field: string,
  errorKey: string,
): boolean => {
  if (!data || !field || !errorKey) return false;
  const errors = data.errors;
  if (errors) {
    if (!Array.isArray(errors[field])) return false;
    if (errors[field] && errors[field].includes(errorKey)) return true;
  } else if (data.message) {
    // Fallback for non-standard error responses
    // for specific duplicated name error messages
    const messageLower = data.message.toLowerCase();
    if (
      messageLower.includes("name") &&
      messageLower.includes("already exists") &&
      errorKey === "validation.unique" &&
      field === "name"
    ) {
      return true;
    }
  }
  return false;
};
